// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__bIsUi","label":"CategoryService_label__riZu1","location":"CategoryService_location__21_a0"};